import { Path, Svg, SVGProps } from "@react-pdf/renderer";

export const RelationshipsIcon = (props: SVGProps) => (
  <Svg {...props} viewBox="0 0 28 28">
    <Path
      d="M16.8876 16.308C18.1324 16.308 19.1416 15.3121 19.1416 14.0837C19.1416 12.8552 18.1324 11.8594 16.8876 11.8594C15.6428 11.8594 14.6336 12.8552 14.6336 14.0837C14.6336 15.3121 15.6428 16.308 16.8876 16.308ZM16.8876 16.308C14.8959 16.308 13.2812 17.503 13.2812 18.9772M16.8876 16.308C18.8793 16.308 20.494 17.503 20.494 18.9772"
      fill="none"
      strokeWidth="1.51847"
      strokeLinecap="round"
    />
    <Path
      d="M11.1142 13.8077C12.359 13.8077 13.3681 12.7455 13.3681 11.4351C13.3681 10.1248 12.359 9.0625 11.1142 9.0625C9.86933 9.0625 8.8602 10.1248 8.8602 11.4351C8.8602 12.7455 9.86933 13.8077 11.1142 13.8077ZM11.1142 13.8077C9.12243 13.8077 7.50781 15.0824 7.50781 16.6548M11.1142 13.8077C13.1059 13.8077 14.7205 15.0824 14.7205 16.6548"
      fill="none"
      strokeWidth="1.51847"
      strokeLinecap="round"
    />
  </Svg>
);
